import { CmsComponents, CmsPlaceholders } from 'src/lib/constants';
import { loadJobsDataForPlaceholder } from '../Careers/helpers';

export interface IGetPlaceholderProps {
  entry: any;
  placeholder: string;
}

/**
 * Gets a placeholder.
 * Note: This process is currently a singleton, and only returns the first found instance of a placeholder.
 */
export const getPlaceholder = ({
  entry,
  placeholder,
}: IGetPlaceholderProps) => {
  return entry?.fields?.components?.find((component) => {
    const componentTypeId = component.sys?.contentType?.sys?.id;

    // if we hit a background conainer, check in the container
    if (componentTypeId === CmsComponents.BACKGROUND_CONTAINER) {
      return getPlaceholder({ entry: component, placeholder });
    }
    return (
      componentTypeId === CmsComponents.PLACEHOLDER &&
      component.fields?.placeholder === placeholder
    );
  });
};

/**
 * Augments contentful field level data with specific information loaded for placeholders.
 */
export const augmentPlaceholderData = async ({ entry }) => {
  // if entry contains careers search placeholder - load jobs data
  const jobsPlaceholder = getPlaceholder({
    entry,
    placeholder: CmsPlaceholders.CAREERS_SEARCH,
  });
  if (jobsPlaceholder) {
    jobsPlaceholder.fields = jobsPlaceholder?.fields ?? {};
    jobsPlaceholder.fields['jobsData'] = await loadJobsDataForPlaceholder();
  }
};
